import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Modal } from 'antd';

type Props = {
  open: boolean;
  message: string;
  title: string;
  onOk: () => void;
  onCancel: () => void;
};
export const WarningModal = ({
  open,
  message,
  title,
  onOk,
  onCancel,
}: Readonly<Props>) => {
  return (
    <Modal
      okText="OK"
      okButtonProps={{ style: { backgroundColor: '#64ABA9' } }}
      cancelText="Cancel"
      onOk={onOk}
      onCancel={onCancel}
      open={open}
      title={
        <span style={{ color: '#faad14' }}>
          <ExclamationCircleOutlined
            style={{ marginRight: 8, color: '#faad14' }}
          />
          {title}
        </span>
      }
    >
      <p className="text-[16px]" style={{ whiteSpace: 'pre-line' }}>
        {message}
      </p>
    </Modal>
  );
};
